import { io } from 'socket.io-client';

export const socket = io(`${location.protocol}//${location.host}`, {
  path: `${process.env.BASE_URL}api/ws`,
});
